import { create } from 'zustand'
import type { UserProfile, UserPreferences, UserSettings } from '@/types/user'

interface UserState {
  profile: UserProfile | null
  preferences: UserPreferences | null
  settings: UserSettings | null
  profileLoaded: boolean
  setProfile: (profile: UserProfile | null) => void
  setPreferences: (preferences: UserPreferences | null) => void
  setSettings: (settings: UserSettings | null) => void
  setProfileLoaded: (loaded: boolean) => void
  reset: () => void
}

export const useUserStore = create<UserState>((set) => ({
  profile: null,
  preferences: null,
  settings: null,
  profileLoaded: false,
  setProfile: (profile) => set({ profile }),
  setPreferences: (preferences) => set({ preferences }),
  setSettings: (settings) => set({ settings }),
  setProfileLoaded: (profileLoaded) => set({ profileLoaded }),
  reset: () => set({ profile: null, preferences: null, settings: null, profileLoaded: false }),
}))
